'use strict';

import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

import {INIT_TABS} from "../scripts/init.tab-slider.js";

const detailGallerySelector = '[data-swiper="detail-page-gallery"]';
new Swiper(detailGallerySelector, {
  modules: [Navigation, Pagination],

  slidesPerView: 'auto',

  breakpoints: {
    320: {
      spaceBetween: 8,
    },

    568: {
      spaceBetween: 16,
    }
  },

  pagination: {
    el: `${detailGallerySelector} + .row .swiper-pagination`,
    type: 'progressbar',
  },

  navigation: {
    nextEl: `${detailGallerySelector} + .row .swiper-button-next`,
    prevEl: `${detailGallerySelector} + .row .swiper-button-prev`,
  },
});

const siblingsGallerySelector = '[data-swiper="detail-page-sibling-slider"]';
new Swiper(siblingsGallerySelector, {
  modules: [Navigation, Pagination],

  breakpoints: {
    320: {
      spaceBetween: 8,
      slidesPerView: 1.1,
    },

    568: {
      spaceBetween: 16,
      slidesPerView: 1.5,
    },

    992: {
      spaceBetween: 24,
      slidesPerView: 2.5,
    },

  },

  pagination: {
    el: `${siblingsGallerySelector} + .row .swiper-pagination`,
    type: 'progressbar',
  },

  navigation: {
    nextEl: `${siblingsGallerySelector} + .row .swiper-button-next`,
    prevEl: `${siblingsGallerySelector} + .row .swiper-button-prev`
  },
});

INIT_TABS();
